import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';

export const useSceneReady = (onReady) => {
	const { gl, camera, scene } = useThree();

	useEffect(() => {
		let animationFrameId;
		let timeoutId;

		const checkRenderComplete = () => {
			animationFrameId = requestAnimationFrame(checkRenderComplete);
			if (gl.info.render.frame % 2 === 0) {
				// React has finished rendering the changes
				cancelAnimationFrame(animationFrameId);
				timeoutId = setTimeout(() => {
					onReady();
				},100);
			}
		};

		checkRenderComplete();

		return () => {
			cancelAnimationFrame(animationFrameId);
			clearTimeout(timeoutId);
		}
	}, [gl, scene, camera, onReady]);
};
